import React from "react";
import { useImmer } from "use-immer";

import { IgPaper } from "@intelligems/ig-theme";
import {
  CouponType,
  STRIPE_LATEST_PRODUCT_VERSION,
  StripeInterval,
} from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { BillingHeader } from "@src/components/BillingPanel/components/BillingHeader/BillingHeader";
import { ManagePlans } from "@src/components/BillingPanel/components/ManagePlans/ManagePlans";
import { ManageSubscriptionsDialog } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/ManageSubscriptionsDialog";
import { Products } from "@src/components/BillingPanel/components/Products/Products";
import { WaitForShopifyDialog } from "@src/components/BillingPanel/components/WaitForShopifyDialog/WaitForShopifyDialog";

import { CouponSection } from "./components/CouponSection/CouponSection";
import { ModifyStripeSubscriptionDialog } from "./components/ManageSubscriptionsDialog/ModifyStripeSubscriptionDialog";

interface BillingPanelProps {
  managePlans: boolean;
}

export const BillingPanel = ({ managePlans }: BillingPanelProps) => {
  const adminOrg = useGetOrganizationSummary();

  const [billingInterval, setBillingInterval] = useImmer<StripeInterval>(
    adminOrg.data.org.stripeSubscriptionSummaries.find((s) =>
      ["active", "trialing"].includes(s.status)
    )?.interval || "month"
  );
  const [coupon, setCoupon] = useImmer<CouponType | null>(null);

  return (
    <IgPaper id={"intelligems-plan"}>
      <Grid container direction={"row"} rowSpacing={5}>
        <BillingHeader
          billingInterval={billingInterval}
          setBillingInterval={setBillingInterval}
        />
        <Products billingInterval={billingInterval} coupon={coupon} />
        <CouponSection coupon={coupon} setCoupon={setCoupon} />
        <WaitForShopifyDialog />
        {managePlans ? (
          <>
            <ManagePlans />
            <ManageSubscriptionsDialog />
            <ModifyStripeSubscriptionDialog />
          </>
        ) : null}
      </Grid>
    </IgPaper>
  );
};
